import { render, staticRenderFns } from "./InactivityWarning.vue?vue&type=template&id=8cc5621c&scoped=true&"
import script from "./InactivityWarning.vue?vue&type=script&lang=js&"
export * from "./InactivityWarning.vue?vue&type=script&lang=js&"
import style0 from "./InactivityWarning.vue?vue&type=style&index=0&id=8cc5621c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc5621c",
  null
  
)

export default component.exports